import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FileUploadApiService } from '../../../../../services/api/file-upload-api.service';

@Component({
    selector: 'website-builder-image-upload',
    templateUrl: './website-builder-image-upload.component.html',
    styleUrls: ['./website-builder-image-upload.component.scss']
})
export class WebsiteBuilderImageUploadComponent {

    @Output() imageUpload: EventEmitter<string> = new EventEmitter();

    isFileOver: boolean;

    options;

    constructor(private uploadService: FileUploadApiService) {
    }

    /**
     * Process event on file input
     *
     * @param event
     */
    onFileInput(event) {
        if(event.target.files.length) {
            this.uploadFile(event.target.files[0]);
        }
    }

    /**
     * Process event on file drop
     *
     * @param event
     */
    onFileDrop(event: DragEvent) {
        if(event.dataTransfer.files.length) {
            this.uploadFile(event.dataTransfer.files[0]);
        }
    }

    private uploadFile(file: File) {
        this.uploadService.fileUpload(file).subscribe(document => this.imageUpload.next(document.link));
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/website-builder-side-editor/common/website-builder-image-upload/website-builder-image-upload.component.ts